import { render, staticRenderFns } from "./ItemMemoryiqTheory.vue?vue&type=template&id=bf9e0dc8&"
import script from "./ItemMemoryiqTheory.vue?vue&type=script&lang=js&"
export * from "./ItemMemoryiqTheory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ItemMemoryiqTheory.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports